import { useEffect } from "react";
import { useToast } from "reshaped";

import { getErrorMessage } from "../form/utilities";

type PromiseToastProps = {
    promise: Promise<void> | null;
    message?: string;
};

const shown = new WeakSet<Promise<void>>();

export function PromiseToast(props: PromiseToastProps) {
    const { promise, message = "C'est fait !" } = props;
    const toast = useToast();
    useEffect(() => {
        if (!promise) return;
        promise
            .then(() => {
                if (shown.has(promise)) return;
                shown.add(promise);
                toast.show({
                    title: message,
                    color: "positive",
                });
            })
            .catch((err) => {
                if (shown.has(promise)) return;
                shown.add(promise);
                toast.show({
                    title: getErrorMessage(err),
                    color: "critical",
                });
            });
    }, [promise, toast, message]);
    return null;
}
